<template>
  <main class="container-fluid pb_50 mb_50 addPayMent" v-if="addPaymentScope">
    <section class="segment pt_12">
      <!-- 要被保人資訊 -->
      <InsuredInfo mode="edit" />
      <!-- 建議明細 -->
      <h4 class="text-green mt_15 mb_10">新增繳費方式</h4>
      <div class="mt_5 text-red fz_13">
        不定期保費不可繳納超過{{ max_age }}歲(含)。
      </div>
      <!-- 不定期保費: -->
      <div class="mt_10">
        <h5>不定期保費:</h5>
        <div
          class="row mt_10"
          v-for="(item, index) in addPaymentScope.flexiblePrem"
          :key="index"
        >
          <div class="col-3">
            <div class="d-flex align-items-center">
              <input
                ype="tel"
                maxlength="2"
                class="form-control mr_2"
                style="width: 4.5rem"
                @input="ageFormat(item, 'start_age')"
                v-model.trim="item.start_age"
                :class="{
                  'is-invalid':
                    showError &&
                    (!item.start_age ||
                      item.start_age * 1 < MfEditing.insured.insured_age * 1 ||
                      (index - 1 > -1 &&
                        addPaymentScope.flexiblePrem[index].start_age * 1 <=
                          addPaymentScope.flexiblePrem[index - 1].end_age * 1)),
                }"
              />
              <strong class="mr_2">歲 ~ </strong>
              <input
                ype="tel"
                maxlength="2"
                class="form-control mr_2 ml_2"
                style="width: 4.5rem"
                @input="ageFormat(item, 'end_age')"
                v-model.trim="item.end_age"
                :class="{
                  'is-invalid':
                    showError &&
                    (!item.end_age ||
                      item.end_age * 1 < item.start_age * 1 ||
                      item.end_age * 1 > max_age * 1 ),
                }"
              />
              <strong>歲:</strong>
            </div>
          </div>
          <div class="col-7">
            <div class="d-flex mr_10 align-items-center">
              <strong>每年繳費:</strong>
              <input
                ype="tel"
                class="form-control mr_2 ml_2"
                style="width: 7rem"
                :class="{
                  'is-invalid': errors.has(`flexiblePrem_${index}`),
                }"
                :data-vv-name="`flexiblePrem_${index}`"
                v-validate="`required|flexiblePrem`"
                @input="numberHandler(item, 'premium', $event)"
                @blur="numberHandler(item, 'premium', $event)"
                :value="item.premium | formatMethods"
              />元
              <div class="text-red fz_13 ml_5 mr_6  " style="width: 14.5rem;white-space:pre-line;">{{`最低${formatMethods(
                    PRODUCT_FEATURE_DATA.renewal_low_limit
                  )}${currTranser(
                    PRODUCT_FEATURE_DATA.curr,
                    true
                  )}${isVA ?"": `，最高` + formatMethods(
                    premium_ceil
                  )+currTranser(
                    PRODUCT_FEATURE_DATA.curr,
                    true
                  )}\r\n，且需以${formatMethods(
                    PRODUCT_FEATURE_DATA.face_prem_incr_unit
                  )}${currTranser(PRODUCT_FEATURE_DATA.curr, true)}為單位`
                }}
              </div>
              <div
                class="btn btn-default btn-sm px_2 pt_2"
                @click="deletRange('flexiblePrem', index)"
              >
                <img src="@/desktop/views/mf/assets/trash.svg" alt="" />
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mt_10">
          <div
            class="btn btn-default add__button"
            @click="addRange('flexiblePrem')"
          >
            <i class="icon-add_new text-orange i-20 mr_5"></i>
            <div>增加一筆</div>
          </div>
        </div>
      </div>
      <div class="mf_divid mt_15"></div>
    </section>
    <FixedBottom>
      <template slot="@function">
        <div class="d-flex justify-content-end">
          <div
            class="btn btn-default px_5 mr_10"
            type="button"
            @click="goback()"
          >
            返回上一頁
          </div>

          <button
            class="btn btn-primary px_5 mr_10"
            type="button"
            @click="next()"
          >
            預覽
          </button>
        </div>
      </template>
    </FixedBottom>
  </main>
</template>

<script>
import mf_Mixin from "@/desktop/views/mf/mixin";
import FixedBottom from "@/desktop/views/mf/components/fixedBotton";
import Tooltip from "@/desktop/components/ToolTip";
import { Validator } from "vee-validate";
import InsuredInfo from "@/desktop/views/mf/components/InsuredInfo";

import _ from "lodash";

export default {
  mixins: [mf_Mixin],
  components: { FixedBottom, Tooltip, InsuredInfo },
  data() {
    return {
      addPaymentScope: {
        flexiblePrem: [], //不定期保費
      },
      showError: false,
      max_age: 99,
      isVA: false,
      pol_premium: 0,
      premium_ceil: 0,
    };
  },
  computed: {
    MfEditing() {
      return this.$store.getters.MfEditing;
    },
    nowProduct() {
      return this.MfEditing.mc_prod_list[0];
    },
    PRODUCT_FEATURE_DATA() {
      return this.MfEditing.mc_prod_list[0].FEATURE_DATA;
    },
    is_crm() {
      return this.MfEditing.inputType == "noId" ? "0" : "1";
    },
    amt_formatVal() {
      if (this.PRODUCT_FEATURE_DATA.amt_unit == "") {
        return 1;
      } else {
        return this.$amtUnitFormat(this.PRODUCT_FEATURE_DATA.amt_unit);
      }
    },
  },
  created() {
    if (!this.nowProduct) {
      this.$router.replace("/mf");
    }
    this.init();
    //已有年齡資料時，直接顯示原本年齡檢核樣式
    this.showError = this.checkHasAgeData();
  },

  methods: {
    init() {
      /**
       * 1.已存完建議書 --> 再次讀取 this.nowProduct.paymethod
       * 2.預覽 --> 修改 --> 回到繳費方式頁面 this.nowProduct.temp__paymethod
       */
      if (this.nowProduct.paymethod && this.nowProduct.paymethod != "{}") {
        //是否有修改過資料
        const isTemp__paymethod = this.nowProduct.hasOwnProperty(
          "temp__paymethod"
        );
        // 有些修改過資料，返回上一頁 this.nowProduct.temp__paymethod = null
        if (isTemp__paymethod) {
          this.nowProduct.temp__paymethod !== null
            ? (this.addPaymentScope = _.cloneDeep(
                this.nowProduct.temp__paymethod
              ))
            : (this.addPaymentScope = JSON.parse(this.nowProduct.paymethod));
        } else {
          this.addPaymentScope = JSON.parse(this.nowProduct.paymethod);
        }
      } else if (this.nowProduct.temp__paymethod) {
        this.addPaymentScope = _.cloneDeep(this.nowProduct.temp__paymethod);
      } else {
        this.addPaymentScope.flexiblePrem = [];
      }
      Validator.extend(`flexiblePrem`, {
        getMessage: "保費金額錯誤",
        validate: (value) => {
          let intValue = parseInt(value.split(",").join(""));
          let incr_unit =
            this.PRODUCT_FEATURE_DATA.face_prem_incr_unit == "0"
              ? 1
              : this.PRODUCT_FEATURE_DATA.face_prem_incr_unit;
          return (
            intValue >= this.PRODUCT_FEATURE_DATA.renewal_low_limit &&
            intValue % incr_unit === 0 &&
            this.premium_ceil >= intValue
          );
        },
      });
      let pol_period = parseInt(this.PRODUCT_FEATURE_DATA.pol_period);
      this.max_age = this.nowProduct.dueage
        ? Math.min(parseInt(this.nowProduct.dueage), pol_period) - 1
        : pol_period - 1;
      this.isVA = new Boolean(this.nowProduct.dueage).valueOf(); //是否為年金商品
      this.pol_premium = parseInt(this.nowProduct.pol_premium);
      let pay_freq = this.nowProduct.pay_freq;
      if ("1" == pay_freq) {
        this.pol_premium = this.pol_premium * 12;
      } else if ("2" == pay_freq) {
        this.pol_premium = this.pol_premium * 4;
      } else if ("3" == pay_freq) {
        this.pol_premium = this.pol_premium * 2;
      }
      this.premium_ceil = this.isVA
        ? Infinity
        : parseInt(this.PRODUCT_FEATURE_DATA.renewal_yr_prem_lmt) -
          this.pol_premium;
      setTimeout(() => {
        this.registerHanlink();
      }, 500);
    },
    goback() {
      this.$mfNotice(
        " 返回上一頁將不儲存本次編輯內容!",
        () => {
          this.nowProduct.temp__paymethod = null;
          this.$router.push("/mf/create");
        },
        true,
        () => {},
        "確定",
        "<div class='fz_20'>不儲存本次編輯內容請點擊「確定」，若欲儲存請點擊「取消」，並繼續編輯。</div>"
      );
    },
    async next() {
      this.showError = true;
      let premiumCheck = await this.$validator.validateAll();
      if (this.checkAgeRange() && premiumCheck) {
        this.nowProduct.temp__paymethod = _.cloneDeep(this.addPaymentScope);
        this.$router.push("/mf/create/paymentPreview3");
      } else {
        this.$toast.info({
          title: "請檢視必填欄位是否漏填或填寫內容有誤! ",
        });
      }
    },
    addRange(targetKey) {
      let start_age =
        this.addPaymentScope[targetKey].length == 0
          ? this.MfEditing.insured.insured_age * 1 + 1 + ""
          : "";
      this.addPaymentScope[targetKey].push({
        start_age: start_age,
        end_age: "",
        premium: "",
      });
    },
    deletRange(targetKey, index) {
      this.addPaymentScope[targetKey].splice(index, 1);
    },
    checkHasAgeData() {
      for (let key in this.addPaymentScope) {
        let dataList = this.addPaymentScope[key];

        if (!Array.isArray(dataList)) continue;

        for (let i = 0; i < dataList.length; i++) {
          if (dataList[i].start_age || dataList[i].end_age) {
            return true;
          }
        }
      }

      return false;
    },
    checkAgeRange() {
      let error = () => {
        this.$toast.info({
          title:
            "後面輸入的歲數不可小於(或等於)前面的歲數，並注意需在被保險人年齡與給付年齡之間!",
        });
        return false;
      };
      let flexiblePrem = this.addPaymentScope.flexiblePrem;
      let insured_age = this.MfEditing.insured.insured_age;
      for (let i = 0; i < flexiblePrem.length; i++) {
        if (
          !flexiblePrem[i].start_age ||
          !flexiblePrem[i].end_age ||
          flexiblePrem[i].start_age * 1 < insured_age * 1 ||
          flexiblePrem[i].end_age * 1 > this.max_age * 1 ||
          flexiblePrem[i].end_age * 1 < flexiblePrem[i].start_age * 1 ||
          (i > 0 &&
            flexiblePrem[i].start_age * 1 <= flexiblePrem[i - 1].end_age * 1)
        ) {
          error();
          return false;
        }
      }
      return true;
    },
  },
  beforeRouteLeave(to, from, next) {
    if (from.path == "/mf/create/addPayment3") {
      let reset = () => {
        setTimeout(() => {
          this.$store.commit("reset_MfEditing");
        }, 500);
        next();
      };
      if (to.path == "/mf/create/paymentPreview3" || to.path == "/mf/create") {
        next();
      } else {
        this.$mfNotice(
          "本建議書尚未完成，是否確定放棄?",
          () => {
            reset();
          },
          true,
          null,
          "確定放棄",
          "",
          "",
          "繼續輸入"
        );
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.addPayMent {
  &__customer {
    display: flex;
    align-items: center;
    font-size: 18px;
    &__role {
      width: 114px;
      font-weight: 700;
    }
    &__name {
      display: flex;
      align-items: center;
    }
  }
  .add__button {
    width: 150px;
    height: 42px;
    border-radius: 4px;
    border: solid 1px #f58818;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    color: #f58818;
    cursor: pointer;
    font-weight: 700;
    line-height: 1;
    white-space: nowrap;
    &__icon {
      padding: 0;
      font-size: 36px;
      color: #f58818;
      line-height: 1;
      font-family: serif;
      font-weight: 700;
    }
  }
}
</style>
